import { badgeVariants, type BadgeVariants } from "@/components/ui/badge";
import type { SurveyStatus } from "@/types";

export const SURVEY_STATUS_VARIANTS: Record<SurveyStatus, BadgeVariants["variant"]> = {
  draft: "neutral",
  review: "warning",
  live: "teal",
  paused: "warning",
  complete: "neutral",
  archive: "neutral",
};

export const surveyStatusClasses = (status: string) =>
  badgeVariants({ variant: SURVEY_STATUS_VARIANTS[status as SurveyStatus] ?? "neutral" });
